import { render, staticRenderFns } from "./RadialBarChart.vue?vue&type=template&id=715d3e84&scoped=true"
import script from "./RadialBarChart.vue?vue&type=script&lang=ts"
export * from "./RadialBarChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715d3e84",
  null
  
)

export default component.exports